import CookieStorage from 'Core/commons/CookieStorage';
import Store from 'Services/Store';

const QUERY_TIMEOUT = 120000;
let pendingTokenRequest = null;

export function onAuthError(error) {
    window.Push.error(error);
    setTimeout(function () {
        Utils.reload();
    }, 3000);
}

/**
 * Get authorization token (shared across ApiClient and ApiBatchClient).
 * Caches in cookie storage and dedupes concurrent refresh requests.
 * @returns {Promise<string>}
 */
export function getAuthorizationToken() {
    const currentStaffId = Store.get('user').id;
    const cookieStorage = new CookieStorage('api', 'access_token');
    const cached = cookieStorage.get();
    if (cached) {
        const expire = new Date(cached.expireAt).getTime() - 60000;
        const now = new Date().getTime();
        if (cached.staffId === currentStaffId && expire > now) {
            return Promise.resolve('Bearer ' + cached.token);
        }
    }

    if (pendingTokenRequest) {
        return pendingTokenRequest;
    }

    const client = axios.create({
        timeout: QUERY_TIMEOUT,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
    });

    pendingTokenRequest = new Promise(function (resolve, reject) {
        client.post('/web-token').then(function (response) {
            if (response.status !== 201 || !response.data.token) {
                return reject(
                    new Error(window.i18n.gettext("Une erreur d'authentification s'est produite")),
                );
            }

            const cachedData = response.data;
            cachedData.staffId = currentStaffId;
            cookieStorage.set(cachedData);

            return resolve('Bearer ' + response.data.token);
        }, onAuthError);
    }).finally(function () {
        pendingTokenRequest = null;
    });

    return pendingTokenRequest;
}
